import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";

@Component({
    selector: "app-drag-drop-files",
    templateUrl: "./drag-drop-files.component.html",
    styleUrl: "./drag-drop-files.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DragDropFilesComponent implements OnInit {
  @Input() acceptedExtensions: string = "";
  @ViewChild("fileDropRef", { static: true }) fileDropRef: any;

  app = getApp((app) => {
    this.app = app;
  });

  ngOnInit() {
    console.log("accepedExtensions: ", this.acceptedExtensions);
  }

  async upload() {
    const files: FileList = this.fileDropRef.nativeElement.files;

    if (files && files.length > 0) {
      const file = files[0];
      await this.app.import.upload(files);
      // Handle the file upload logic here
    } else {
      console.log("No file selected.");
    }
  }
}
